// El eje contrario al de la estacion de entrega.
//
// La estacion pregunta "¿quien necesita JERSEY?" -- sirve para repartir una prenda,
// una caja a la vez. Esto pregunta "¿que le falta a este jugador?" -- sirve para el
// dia que mides al equipo junto: lo llamas por lista UNA vez y capturas sus tres
// tallas, en lugar de pasar lista tres veces cambiando de prenda.
export const filasPorJugador = (entregas = [], jugadorById = {}) => {
  const porJugador = new Map()

  ;(entregas || []).forEach((e) => {
    const jugador = jugadorById[e.jugador_id]
    if (!jugador) return   // fuera del padron: no se inventa un renglon
    if (!porJugador.has(e.jugador_id)) {
      porJugador.set(e.jugador_id, { jugador, porPrenda: {}, sinTalla: 0 })
    }
    const fila = porJugador.get(e.jugador_id)
    // Una celda por prenda: gana la PRIMERA, que es la de la parrilla (la del plan).
    // Un extra de la misma prenda ya trae su talla puesta desde que se vendio, asi
    // que no hay nada que medirle -- y sobreescribir la del plan escondería lo que
    // si falta capturar.
    if (fila.porPrenda[e.prenda_id]) return
    fila.porPrenda[e.prenda_id] = e
    if (!e.talla) fila.sinTalla += 1
  })

  return [...porJugador.values()].sort(
    (a, b) => (a.jugador.nombre_completo || '').localeCompare(b.jugador.nombre_completo || ''),
  )
}

// Las prendas que de verdad aparecen en estas filas, en el orden del catalogo.
// Pintar una columna por cada prenda de la organizacion llenaria la tabla de columnas
// vacias: en un padron de FLAG no tiene nada que hacer la columna de FUNDA de tackle.
export const prendasPresentes = (entregas = [], prendas = []) => {
  const usadas = new Set((entregas || []).map((e) => e.prenda_id))
  return (prendas || []).filter((p) => usadas.has(p.id))
}
